<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QisYDQ/tc-custom/9780253011459.jpg?1713384435640" alt="This image is the cover for the book Calls of Islam, Public Cultures of the Middle East and North Africa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Calls of Islam, Public Cultures of the Middle East and North Africa
      </h1>
      <p class="bookDescription body article font2">
        <b>“A theoretically sophisticated reading of the mediation of social and spiritual relationships in Fez.” —Gregory Starrett, University of North Carolina at Charlotte</b><br/><br/>The sacred calls that summon believers are the focus of this study of religion and power in Fez, Morocco. Focusing on how dissemination of the call through mass media has transformed understandings of piety and authority, Emilio Spadola details the new importance of once-marginal Sufi practices such as spirit trance and exorcism for ordinary believers, the state, and Islamist movements. <i>The Calls of Islam</i> offers new ethnographic perspectives on ritual, performance, and media in the Muslim world.<br/><br/><b>“A superb demonstration of anthropological analysis at its best. A major contribution to our understanding of the complicated nexus of religion, nationalism, and technology.” —Charles Hirschkind, author of <i>The Feeling of History</i></b><br/><br/><b>“An instructive contribution to the literature on Morocco’s socio-cultural and political idiosyncrasies.” —<i>Review of Middle East Studies</i></b><br/><br/><b>“Spadola’s dense but short study . . . manages admirably well to deal with a complex topic, skillfully balancing ethnographic and analytic elements.” —<i>American Ethnologist</i></b><br/><br/><b>“[The] tension between social classes is subtly drawn out throughout this exemplary book, and Spadola also does a magnificent job tying local, national, and transnational contexts together. Although writing about a very specific place and time, he manages to capture post-millennial anxieties about Islam and belonging that are far reaching in their scope.” —<i>Contemporary Islam</i></b><br/><br/><b>“Spadola’s book is theoretically sophisticated, skillfully constructed, and rich in detail.” —<i>Journal of Religion</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emilio Spadola
      </h2>
      
      <p class="authorDescription body article"><P>Emilio Spadola is Associate Professor of Anthropology at Colgate University.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a636cd1